import React from 'react';

const UserGroupIcon: React.FC = () => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="3" stroke="currentColor" strokeWidth="1.3" />
      <path
        d="M7 11C6.5 11 6.38418 11 6 11C5.17157 11 4.5 10.3284 4.5 9.5C4.5 8.67157 5.17157 8 6 8C6.38418 8 6.73462 8.14443 7 8.38195"
        stroke="currentColor"
        strokeWidth="1.3"
      />
      <path
        d="M17 11C17.5 11 17.6158 11 18 11C18.8284 11 19.5 10.3284 19.5 9.5C19.5 8.67157 18.8284 8 18 8C17.6158 8 17.2654 8.14443 17 8.38195"
        stroke="currentColor"
        strokeWidth="1.3"
      />
      <path
        d="M12 13.5C9.03079 13.5 6.56533 15.2553 6.08479 18.0042C5.98969 18.5483 6.44772 19 7 19H17C17.5523 19 18.0103 18.5483 17.9152 18.0042C17.4347 15.2553 14.9692 13.5 12 13.5Z"
        stroke="currentColor"
        strokeWidth="1.3"
      />
      <path
        d="M6 13C4.13252 13 2.56394 14.2798 2.12343 16.0101C1.98717 16.5453 2.44772 17 3 17H4.5"
        stroke="currentColor"
        strokeWidth="1.3"
      />
      <path
        d="M18 13C19.8675 13 21.4361 14.2798 21.8766 16.0101C22.0128 16.5453 21.5523 17 21 17H19.5"
        stroke="currentColor"
        strokeWidth="1.3"
      />
    </svg>
  );
};

export default UserGroupIcon;
